import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    { name: t('compare.rowSpreadsheet'), best: t('compare.rowSpreadsheetBest'), guides: true, comparison: true, safety: true },
    { name: t('compare.rowDirectory'), best: t('compare.rowDirectoryBest'), guides: true, comparison: true, safety: true },
    { name: t('compare.rowShipping'), best: t('compare.rowShippingBest'), guides: true, comparison: false, safety: true },
    { name: t('compare.rowReview'), best: t('compare.rowReviewBest'), guides: true, comparison: true, safety: true },
  ];

  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
            {t('compare.title')}
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-stone-200">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[560px] text-left text-sm">
              <thead>
                <tr className="bg-stone-50 text-xs uppercase tracking-wide text-stone-500">
                  <th className="px-4 py-3 font-medium">{t('compare.colResource')}</th>
                  <th className="px-4 py-3 font-medium">{t('compare.colBestFor')}</th>
                  <th className="px-4 py-3 text-center font-medium">{t('compare.colGuides')}</th>
                  <th className="px-4 py-3 text-center font-medium">{t('compare.colComparison')}</th>
                  <th className="px-4 py-3 text-center font-medium">{t('compare.colSafety')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.name} className="border-t border-stone-100">
                    <td className="whitespace-nowrap px-4 py-3 font-medium text-stone-800">{row.name}</td>
                    <td className="whitespace-nowrap px-4 py-3 text-stone-500">{row.best}</td>
                    <td className="px-4 py-3 text-center">
                      <Check value={row.guides} />
                    </td>
                    <td className="px-4 py-3 text-center">
                      <Check value={row.comparison} />
                    </td>
                    <td className="px-4 py-3 text-center">
                      <Check value={row.safety} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}

function Check({ value }: { value: boolean }) {
  return value ? (
    <span className="inline-flex h-5 w-5 items-center justify-center text-emerald-600">
      <i className="ri-check-line"></i>
    </span>
  ) : (
    <span className="inline-flex h-5 w-5 items-center justify-center text-stone-300">—</span>
  );
}